import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { InviteUsersModalComponent } from './invite-users-modal/invite-users-modal.component';
import { MainModalComponent } from './main-modal/main-modal.component';
import { UpgradePlanModalComponent } from './upgrade-plan-modal/upgrade-plan-modal.component';
import {ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {OwlDateTimeModule} from "@danielmoncada/angular-datetime-picker";
import {AutosizeModule} from "ngx-autosize";
import {SharedPipesModule} from "../../../../pipes/shared-pipes/shared-pipes.module";

@NgModule({
  declarations: [
    InviteUsersModalComponent,
    MainModalComponent,
    UpgradePlanModalComponent
  ],
    imports: [CommonModule, InlineSVGModule, RouterModule, ReactiveFormsModule, NgSelectModule, OwlDateTimeModule, AutosizeModule,SharedPipesModule],
  exports: [
    InviteUsersModalComponent,
    MainModalComponent,
    UpgradePlanModalComponent,
  ],
})
export class ModalsModule {}
